import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInPath } from 'common/config/urls';
import { SIGN_IN_VIEW } from 'common/constants/auth';
import { useLogOutUser } from 'pages/Auth/hooks';
import { buildSignInUrl, subscribeToAuthSessionSync } from 'pages/Auth/utils';

const AuthSessionBridge = () => {
  const navigate = useNavigate();
  const logOutRemoteUser = useLogOutUser({
    broadcastSessionLogout: false,
    noRedirect: true,
  });

  useEffect(() => {
    const unsubscribe = subscribeToAuthSessionSync({
      onRemoteLogout: () => {
        logOutRemoteUser();

        if (window.location.pathname === signInPath) {
          return;
        }

        navigate(buildSignInUrl({ view: SIGN_IN_VIEW.IDENTIFIER }), { replace: true });
      },
    });

    return () => {
      unsubscribe();
    };
  }, [logOutRemoteUser, navigate]);

  return null;
};

export default AuthSessionBridge;
